import * as MaterialUiIcons from "@mui/icons-material";
import * as React from "react";
import { FunctionComponent } from "react";

const AddIcon: FunctionComponent = () => <MaterialUiIcons.Add />;

export default AddIcon;
